var _templateObject, _templateObject2, _templateObject3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React from 'react';
import { bool, node, oneOf, string } from 'prop-types';
import styled from 'styled-components';
import ListGroupItem from './ListGroupItem'; // --- start styled components --------------

var ListComponent = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 20px;\n  margin: 0;\n"])));
ListComponent.displayName = 'ListComponent';
var VerticalList = styled(ListComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  list-style: ", " inside none;\n\n  &.borders > li, &.borders > a,  &.no-borders > li,  &.no-borders > a {\n    &:first-child {\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n    }\n\n    &:last-child {\n      border-bottom-right-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n  }\n\n  &.borders > li, &.borders > a {\n    border-left: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n\n    &:first-child {\n      border-top: 1px solid ", ";\n    }\n  }\n\n  &.flush > li, &.flush > a {\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    border-bottom: 1px solid ", ";\n\n    &:first-child {\n      border-top: none;\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n"])), function (props) {
  return props.listStyleType;
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
});
VerticalList.displayName = 'VerticalList';
var HorizontalList = styled(ListComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex-direction: row;\n  list-style: ", " inside none;\n\n  &.borders > li, &.borders > a,  &.no-borders > li, &.no-borders > a {\n    &:first-child {\n      border-top-right-radius: none;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n  }\n\n  &.borders > li, &.borders > a {\n    border-bottom: 1px solid ", ";\n    border-right: 1px solid ", ";\n    border-top: 1px solid ", ";\n\n    &:first-child {\n      border-top: 1px solid ", ";\n      border-left: 1px solid ", ";\n    }\n  }\n\n  &.flush > li, &.flush > a {\n    border-right: 1px solid ", ";\n    border-top: none;\n    border-bottom: none;\n\n    &:first-child {\n      border-left: none;\n    }\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n"])), function (props) {
  return props.listStyleType;
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
}, function (props) {
  return props.borderColor || '#cfd8dc';
});
HorizontalList.displayName = 'HorizontalList'; // --- end styled components --------------

function ListGroup(_ref) {
  var borders = _ref.borders,
      borderColor = _ref.borderColor,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      flush = _ref.flush,
      horizontal = _ref.horizontal,
      listStyleType = _ref.listStyleType,
      restProps = _objectWithoutProperties(_ref, ["borders", "borderColor", "children", "className", "flush", "horizontal", "listStyleType"]);

  var List = horizontal ? HorizontalList : VerticalList;
  var isFlush = flush === true ? 'flush' : '';
  var borderClass = borders === true ? 'borders' : 'no-borders';
  return /*#__PURE__*/React.createElement(List, _extends({
    borderColor: borderColor,
    className: "scl-list-group ".concat(isFlush, " ").concat(borderClass, " ").concat(className),
    "data-test-id": "scl-list-group",
    listStyleType: listStyleType
  }, restProps), children);
}

ListGroup.propTypes = {
  /**
  Optional for adding borders to a ListGroup. Make sure to pass
  in a borderColor prop if you add borders
  */
  borders: bool,

  /**
  Optional for changing border color on a ListGroup. Defaults to silver.
  */
  borderColor: string,

  /**
  Required and refers to everything included between opening
  and closing tags when invoking component
  */
  children: node.isRequired,

  /**
  Optional className to include in rendered component
  */
  className: string,

  /**
  Optional decorator to remove outer borders. Used for implementing within another component
  like Accordion. Do not pass in borders prop when passing the flush prop.
  */
  flush: bool,

  /**
  Optional and when added will render listGroup horizontally
  */
  horizontal: bool,

  /**
  Optional to control the style of the list item bullet.
  */
  listStyleType: oneOf(['disc', 'circle', 'square', 'decimal'])
};
ListGroup.Item = ListGroupItem;
ListGroup.Item.displayName = 'ListGroup.Item';
export default ListGroup;